// @flow
import type {Node} from 'react'
import React from 'react'
import SummaryUI from 'components/proposals/Part/ui/Summary'
import SummarySections from 'components/proposals/Part/SummarySections'
import type {State} from '../types'

type Props = State

function Summary({change}: Props): Node {
  return (
    <SummaryUI>
      <SummarySections change={change} />
    </SummaryUI>
  )
}

export default Summary
